(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5021],{

/***/ 81103:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/applications/landing",
      function () {
        return __webpack_require__(37034);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(42060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 46941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(46941);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(43100)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 55952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* reexport safe */ _Badge_styled__WEBPACK_IMPORTED_MODULE_0__.C; }
/* harmony export */ });
/* harmony import */ var _Badge_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71487);



/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable, _extraMeta = param.extraMeta, extraMeta = _extraMeta === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : _extraMeta;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl || "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }),
                    extraMeta
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 37034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ landing; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./components/shared/Badge.js
var Badge = __webpack_require__(55952);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./components/shared/Badge.styled.tsx
var Badge_styled = __webpack_require__(71487);
// EXTERNAL MODULE: ./components/shared/Typography.styled.tsx
var Typography_styled = __webpack_require__(90637);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/applications/ApplicationsCompanies.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  margin: auto;\n\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n  margin-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: initial;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  max-width: 25rem;\n\n  @media (min-width: ",
        ") {\n    width: 33.333%;\n    max-width: unset;\n  }\n\n  ",
        " {\n    margin-top: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  width: 5rem;\n  height: 5rem;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  position: relative;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: -",
        ";\n    left: 0;\n    width: ",
        ";\n    height: ",
        ";\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var StyledCompanies = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3fe81a9b-0"
})(_templateObject(), (0,theme/* color */.$_)("midnight_850"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* color */.$_)("text_default_inverse"));
var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3fe81a9b-1"
})(_templateObject1(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), Typography_styled/* Heading2 */.XJ);
var StyledFeatures = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3fe81a9b-2"
})(_templateObject2(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"));
var StyledFeature = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3fe81a9b-3"
})(_templateObject3(), (0,theme/* color */.$_)("midnight_800"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"), Badge_styled/* Badge */.C, (0,theme/* spacing */.W0)("md"));
var StyledFeatureIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-3fe81a9b-4"
})(_templateObject4());
var StyledFeatureTitle = styled_components_browser_esm/* default.h6.withConfig */.ZP.h6.withConfig({
    componentId: "sc-3fe81a9b-5"
})(_templateObject5(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("cyan_300"));
var StyledFeatureDesc = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-3fe81a9b-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./components/marketingSite/applications/ApplicationsCompanies.tsx







var ApplicationsCompanies = function() {
    var t = (0,useI18n/* useI18n */.Q)("applications-landing").t;
    var features = [
        {
            icon: (0,paths/* getPublicPath */.A)("/images/icons/legal_dark.svg"),
            title: t("applicationsLanding.companies.legal.title"),
            desc: t("applicationsLanding.companies.legal.desc")
        },
        {
            icon: (0,paths/* getPublicPath */.A)("/images/icons/update_dark.svg"),
            title: t("applicationsLanding.companies.updated.title"),
            desc: t("applicationsLanding.companies.updated.desc")
        },
        {
            icon: (0,paths/* getPublicPath */.A)("/images/icons/chat_dark.svg"),
            title: t("applicationsLanding.companies.feedback.title"),
            desc: t("applicationsLanding.companies.feedback.desc"),
            soon: true
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
        id: "jobAppsCompanies",
        name: "jobAppsCompanies",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCompanies, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                        editorial: true,
                        children: t("applicationsLanding.companies.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFeatures, {
                        children: features.map(function(feature, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFeature, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFeatureIcon, {
                                        src: feature.icon,
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFeatureTitle, {
                                        children: feature.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFeatureDesc, {
                                        dangerouslySetInnerHTML: {
                                            __html: feature.desc
                                        }
                                    }),
                                    feature.soon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                        variant: "secondaryInverse",
                                        children: t("applicationsLanding.companies.soon")
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var applications_ApplicationsCompanies = (ApplicationsCompanies);

// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/ButtonLink.js
var ButtonLink = __webpack_require__(68692);
// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
;// CONCATENATED MODULE: ./components/marketingSite/applications/ApplicationsCta.styled.ts

function ApplicationsCta_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding-right: ",
        ";\n  padding-left: ",
        ";\n  text-align: center;\n"
    ]);
    ApplicationsCta_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ApplicationsCta_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    display: block;\n    margin: auto;\n  }\n"
    ]);
    ApplicationsCta_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ApplicationsCta_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: inherit;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.16;\n  margin-top: 0;\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.125;\n    margin-top: ",
        ";\n  }\n"
    ]);
    ApplicationsCta_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ApplicationsCta_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-abfb28a-0"
})(ApplicationsCta_styled_templateObject(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-abfb28a-1"
})(ApplicationsCta_styled_templateObject1());
var StyledTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-abfb28a-2"
})(ApplicationsCta_styled_templateObject2(), (0,theme/* fontWeight */.Ue)("extrabold"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl3"), (0,theme/* spacing */.W0)("md"));

;// CONCATENATED MODULE: ./components/marketingSite/applications/ApplicationsCta.tsx












var ApplicationsCta = function() {
    var t = (0,useI18n/* useI18n */.Q)("applications-landing").t;
    var locale = (0,router.useRouter)().locale;
    var user = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi).user;
    var ctaUrl = "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?source=your_apps_profile");
    if (user) {
        ctaUrl = "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.portalV2Dashboard */.uu.portalV2Dashboard, locale));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ApplicationsCta_styled_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: (0,paths/* getPublicPath */.A)("/images/applicationsLanding/cta.svg"),
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                children: t("applicationsLanding.cta.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: ctaUrl,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                    variant: "brandTalent",
                    sizes: "md",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faCheckCircle */.f8k
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("applicationsLanding.cta.cta")
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var applications_ApplicationsCta = (ApplicationsCta);

// EXTERNAL MODULE: ./components/marketingSite/shared/FaqsItem.tsx
var FaqsItem = __webpack_require__(53307);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 8 modules
var esm = __webpack_require__(7621);
// EXTERNAL MODULE: ./utils/config.ts
var config = __webpack_require__(75339);
;// CONCATENATED MODULE: ./components/marketingSite/applications/ApplicationsFaqs.styled.ts

function ApplicationsFaqs_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n  margin: auto;\n  max-width: calc(",
        " + ",
        " * 2);\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  text-align: center;\n"
    ]);
    ApplicationsFaqs_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ApplicationsFaqs_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        " auto;\n  max-width: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  counter-reset: faqs;\n  text-align: left;\n"
    ]);
    ApplicationsFaqs_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ApplicationsFaqs_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n"
    ]);
    ApplicationsFaqs_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ApplicationsFaqs_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-810c6f4e-0"
})(ApplicationsFaqs_styled_templateObject(), (0,theme/* color */.$_)("sand_100"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledFaqs = styled_components_browser_esm/* default.dl.withConfig */.ZP.dl.withConfig({
    componentId: "sc-810c6f4e-1"
})(ApplicationsFaqs_styled_templateObject1(), (0,theme/* spacing */.W0)("xl"), (0,theme/* container */.nC)("md"), (0,theme/* color */.$_)("midnight_200"));
var StyledFooter = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-810c6f4e-2"
})(ApplicationsFaqs_styled_templateObject2(), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));

;// CONCATENATED MODULE: ./components/marketingSite/applications/ApplicationsFaqs.tsx







var ApplicationsFaqs = function() {
    var t = (0,useI18n/* useI18n */.Q)("applications-landing").t;
    var faqs = [
        {
            active: true,
            question: t("applicationsLanding.faqs.tracking.title"),
            answer: t("applicationsLanding.faqs.tracking.desc")
        },
        {
            question: t("applicationsLanding.faqs.profile.title"),
            answer: t("applicationsLanding.faqs.profile.desc")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ApplicationsFaqs_styled_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                editorial: true,
                children: t("applicationsLanding.faqs.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFaqs, {
                children: faqs === null || faqs === void 0 ? void 0 : faqs.map(function(faq, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqsItem/* default */.Z, {
                        question: faq.question,
                        active: faq.active,
                        answer: faq.answer
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooter, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                    ns: "applications-landing",
                    i18nKey: "applicationsLanding.faqs.footer",
                    values: {
                        mailToSupport: config/* config.supportEmail */.v.supportEmail
                    },
                    components: {
                        mailToSupportLink: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "mailto:".concat(config/* config.supportEmail */.v.supportEmail)
                        })
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var applications_ApplicationsFaqs = (ApplicationsFaqs);

;// CONCATENATED MODULE: ./components/marketingSite/applications/ApplicationsFeatures.styled.ts

function ApplicationsFeatures_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    ApplicationsFeatures_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ApplicationsFeatures_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: ",
        ";\n\n  @media (min-width: ",
        ") {\n    width: 50%;\n  }\n\n  img {\n    display: block;\n  }\n"
    ]);
    ApplicationsFeatures_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ApplicationsFeatures_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  padding-top: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.42;\n\n  @media (min-width: ",
        ") {\n    width: 50%;\n    font-size: ",
        ";\n    line-height: 1.5;\n  }\n\n  ",
        " {\n    &::before {\n      left: 0;\n      transform: translateX(0);\n    }\n  }\n"
    ]);
    ApplicationsFeatures_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ApplicationsFeatures_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column-reverse;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: flex-start;\n  }\n\n  &:last-of-type {\n    @media (max-width: ",
        ") {\n      flex-direction: column;\n    }\n\n    ",
        " {\n      box-shadow: unset;\n    }\n\n    ",
        " {\n      @media (min-width: ",
        ") {\n        text-align: right;\n      }\n    }\n\n    ",
        " {\n      @media (min-width: ",
        ") {\n        &::before {\n          left: unset;\n          right: 0;\n        }\n      }\n    }\n  }\n"
    ]);
    ApplicationsFeatures_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ApplicationsFeatures_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row-reverse;\n  }\n"
    ]);
    ApplicationsFeatures_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var ApplicationsFeatures_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-28f3ad94-0"
})(ApplicationsFeatures_styled_templateObject(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl4"));
var StyledFeatureImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-28f3ad94-1"
})(ApplicationsFeatures_styled_templateObject1(), (0,theme/* shadow */.AF)("md"), (0,theme/* screen */.sp)("md"));
var StyledFeatureContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-28f3ad94-2"
})(ApplicationsFeatures_styled_templateObject2(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("md"), Typography_styled/* Heading3 */.aC);
var ApplicationsFeatures_styled_StyledFeature = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-28f3ad94-3"
})(ApplicationsFeatures_styled_templateObject3(), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("mdMax"), StyledFeatureImage, StyledFeatureContent, (0,theme/* screen */.sp)("md"), Typography_styled/* Heading3 */.aC, (0,theme/* screen */.sp)("md"));
var StyledTitleBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-28f3ad94-4"
})(ApplicationsFeatures_styled_templateObject4(), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("md"));

;// CONCATENATED MODULE: ./components/marketingSite/applications/ApplicationsFeatures.tsx







var ApplicationsFeatures = function() {
    var t = (0,useI18n/* useI18n */.Q)("applications-landing").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ApplicationsFeatures_styled_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ApplicationsFeatures_styled_StyledFeature, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFeatureImage, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,paths/* getPublicPath */.A)("/images/applicationsLanding/".concat(locale, "/feature1.png")),
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFeatureContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                                        editorial: true,
                                        children: t("applicationsLanding.features.experience.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        dangerouslySetInnerHTML: {
                                            __html: t("applicationsLanding.features.experience.desc")
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Heading3 */.aC, {
                                        editorial: true,
                                        children: [
                                            t("applicationsLanding.features.opportunities.title"),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                                variant: "secondary",
                                                sizes: "xs",
                                                children: t("applicationsLanding.features.soon")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        dangerouslySetInnerHTML: {
                                            __html: t("applicationsLanding.features.opportunities.desc")
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ApplicationsFeatures_styled_StyledFeature, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFeatureContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                                        editorial: true,
                                        children: t("applicationsLanding.features.data.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        dangerouslySetInnerHTML: {
                                            __html: t("applicationsLanding.features.data.desc")
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitleBadge, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Heading3 */.aC, {
                                            editorial: true,
                                            children: [
                                                t("applicationsLanding.features.bias.title"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                                    variant: "secondary",
                                                    sizes: "xs",
                                                    children: t("applicationsLanding.features.soon")
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        dangerouslySetInnerHTML: {
                                            __html: t("applicationsLanding.features.bias.desc")
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFeatureImage, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,paths/* getPublicPath */.A)("/images/applicationsLanding/".concat(locale, "/feature2.png")),
                            alt: ""
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var applications_ApplicationsFeatures = (ApplicationsFeatures);

// EXTERNAL MODULE: ./components/shared/ButtonLink.styled.tsx
var ButtonLink_styled = __webpack_require__(8536);
;// CONCATENATED MODULE: ./components/marketingSite/applications/ApplicationsHero.styled.ts

function ApplicationsHero_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: hidden;\n"
    ]);
    ApplicationsHero_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ApplicationsHero_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    ApplicationsHero_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ApplicationsHero_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background-color: ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n  }\n\n  ",
        " {\n    background-image: ",
        ";\n    background-repeat: no-repeat;\n    background-size: contain;\n    aspect-ratio: 30/12;\n\n    @media (max-width: ",
        ") {\n      background-image: ",
        ";\n      background-position: center bottom;\n      aspect-ratio: auto;\n      background-size: cover;\n      clip-path: polygon(0 0, 100% 0, 100% 95%, 0 95%);\n    }\n  }\n\n  ",
        " {\n    color: ",
        ";\n    text-align: center;\n    padding-top: calc(",
        ");\n    padding-bottom: calc(",
        ");\n\n    @media (min-width: ",
        ") {\n      padding-top: calc(",
        " + ",
        ");\n      padding-bottom: 0;\n    }\n  }\n"
    ]);
    ApplicationsHero_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ApplicationsHero_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  height: 1.35em;\n  overflow: hidden;\n"
    ]);
    ApplicationsHero_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ApplicationsHero_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  animation: wordSlider ease-out infinite 12s;\n\n  > span {\n    display: block;\n    line-height: 1.3em;\n    color: ",
        ";\n  }\n\n  @keyframes wordSlider {\n    0%,\n    16% {\n      transform: translateY(0%);\n    }\n    20%,\n    36% {\n      transform: translateY(-16.66%);\n    }\n    40%,\n    56% {\n      transform: translateY(-33.33%);\n    }\n    60%,\n    76% {\n      transform: translateY(-50%);\n    }\n    80%,\n    96% {\n      transform: translateY(-66.66%);\n    }\n    100% {\n      transform: translateY(-83.33%);\n    }\n  }\n"
    ]);
    ApplicationsHero_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ApplicationsHero_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.6;\n  background-image: ",
        ";\n  background-repeat: no-repeat;\n  background-position: left bottom;\n  background-size: cover;\n\n  @media (max-width: ",
        ") {\n    background-image: unset;\n    font-size: ",
        ";\n    line-height: 1.5;\n  }\n\n  ",
        " {\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n    padding-top: ",
        ";\n\n    @media (min-width: ",
        ") {\n      flex-direction: row;\n      justify-content: space-between;\n    }\n\n    @media (max-width: ",
        ") {\n      padding: 0;\n      > div {\n        padding-top: ",
        ";\n        padding-left: ",
        ";\n        padding-right: ",
        ";\n        background-image: ",
        ";\n        background-size: cover;\n        background-position: left 20% top;\n        padding-bottom: ",
        ";\n      }\n    }\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n\n    &::before {\n      left: 0;\n      transform: translate(0);\n    }\n\n    & ~ div {\n      > :first-child {\n        margin-top: 0;\n      }\n      > :last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n  ",
        " {\n    margin-top: ",
        ";\n  }\n\n  img {\n    flex-shrink: 0;\n    display: block;\n    box-shadow: ",
        ";\n    max-width: 18rem;\n\n    @media (max-width: ",
        ") {\n      margin: auto;\n    }\n  }\n"
    ]);
    ApplicationsHero_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var StyledHero = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-c9bd1266-0"
})(ApplicationsHero_styled_templateObject());
var ApplicationsHero_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c9bd1266-1"
})(ApplicationsHero_styled_templateObject1(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var ApplicationsHero_styled_StyledImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c9bd1266-2"
})(ApplicationsHero_styled_templateObject2(), (0,theme/* color */.$_)("white"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"), ApplicationsHero_styled_StyledContainer, function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/applicationsLanding/hero.svg"), "')");
}, (0,theme/* screen */.sp)("mdMax"), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/applicationsLanding/hero_mobile.svg"), "')");
}, Typography_styled/* Heading1 */.nL, (0,theme/* color */.$_)("text_white"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl6"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl"));
var StyledHeadingCarousel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c9bd1266-3"
})(ApplicationsHero_styled_templateObject3());
var StyledHeadingCarouselInner = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c9bd1266-4"
})(ApplicationsHero_styled_templateObject4(), (0,theme/* color */.$_)("text_white"));
var StyledIntro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c9bd1266-5"
})(ApplicationsHero_styled_templateObject5(), (0,theme/* fontSize */.JB)("lg"), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/applicationsLanding/hero-bg.svg"), "')");
}, (0,theme/* screen */.sp)("mdMax"), (0,theme/* fontSize */.JB)("md"), ApplicationsHero_styled_StyledContainer, (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/applicationsLanding/hero-bg.svg"), "')");
}, (0,theme/* spacing */.W0)("xl"), Typography_styled/* Heading2 */.XJ, (0,theme/* spacing */.W0)("lg"), ButtonLink_styled/* ButtonLink */.Z, (0,theme/* spacing */.W0)("xl"), (0,theme/* shadow */.AF)("lg"), (0,theme/* screen */.sp)("mdMax"));

;// CONCATENATED MODULE: ./components/marketingSite/applications/ApplicationsHero.tsx














var Words = function() {
    var t = (0,useI18n/* useI18n */.Q)("applications-landing").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadingCarousel, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeadingCarouselInner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "start",
                    children: t("applicationsLanding.hero.word1")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "aria-hidden": "true",
                    children: t("applicationsLanding.hero.word2")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "aria-hidden": "true",
                    children: t("applicationsLanding.hero.word3")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "aria-hidden": "true",
                    children: t("applicationsLanding.hero.word4")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "aria-hidden": "true",
                    children: t("applicationsLanding.hero.word5")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "aria-hidden": "true",
                    children: t("applicationsLanding.hero.word1")
                })
            ]
        })
    });
};
var ApplicationsHero = function() {
    var t = (0,useI18n/* useI18n */.Q)("applications-landing").t;
    var locale = (0,router.useRouter)().locale;
    var user = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi).user;
    var ctaUrl = "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?returnUrl=/").concat(locale).concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.portalV2ThirdPartyApplications */.uu.portalV2ThirdPartyApplications, locale), "&source=your_apps_application");
    if (user) {
        ctaUrl = "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.portalV2ThirdPartyApplications */.uu.portalV2ThirdPartyApplications, locale));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHero, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicationsHero_styled_StyledImage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicationsHero_styled_StyledContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                            i18nKey: "applicationsLanding.hero.title",
                            ns: "applications-landing",
                            components: {
                                words: /*#__PURE__*/ (0,jsx_runtime.jsx)(Words, {})
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIntro, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ApplicationsHero_styled_StyledContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                                    editorial: true,
                                    dangerouslySetInnerHTML: {
                                        __html: t("applicationsLanding.hero.intro.title")
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: t("applicationsLanding.hero.intro.desc")
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: ctaUrl,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                                        variant: "primary",
                                        sizes: "md",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons/* faCheckCircle */.f8k
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("applicationsLanding.hero.intro.cta")
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,paths/* getPublicPath */.A)("/images/applicationsLanding/".concat(locale, "/analytics.png")),
                            alt: ""
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var applications_ApplicationsHero = (ApplicationsHero);

;// CONCATENATED MODULE: ./components/marketingSite/applications/ApplicationsComponent.tsx







var ApplicationsComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
        hasScrollTop: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(applications_ApplicationsHero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(applications_ApplicationsFeatures, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(applications_ApplicationsCta, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(applications_ApplicationsFaqs, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(applications_ApplicationsCompanies, {})
        ]
    });
};
/* harmony default export */ var applications_ApplicationsComponent = (ApplicationsComponent);

// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
;// CONCATENATED MODULE: ./pages/applications/landing.tsx







var ApplicationsLandingPage = function(param) {
    var baseUrl = param.baseUrl;
    var t = (0,useI18n/* useI18n */.Q)("applications-landing").t;
    (0,usePageTrack/* usePageTrack */.N)("Website - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("applicationsLanding.page_title"),
                desc: t("applicationsLanding.page_desc"),
                url: app_urls/* APP_URLS.cvApplicationsLanding */.uu.cvApplicationsLanding,
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_jobapplicationslanding.png")),
                indexable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(applications_ApplicationsComponent, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var landing = (ApplicationsLandingPage);


/***/ }),

/***/ 63201:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81192:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95805)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,625,4882,7265,9774,2888,179], function() { return __webpack_exec__(81103); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);